import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CustomerContextService } from '../services/customer-context.service';

@Injectable()
export class CustomerTerminologyInterceptor implements HttpInterceptor {
  constructor(private customerContext: CustomerContextService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map(event => {
        if (!(event instanceof HttpResponse)) {
          return event;
        }
        const body = this.translateErrorMessage(event.body);
        return body === event.body ? event : event.clone({ body });
      }),
      catchError(error => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }
        const translatedError = this.translateErrorMessage(error.error);
        if (translatedError === error.error) {
          return throwError(() => error);
        }
        return throwError(() => new HttpErrorResponse({
          error: translatedError,
          headers: error.headers,
          status: error.status,
          statusText: error.statusText,
          url: error.url ?? undefined
        }));
      })
    );
  }

  private translateErrorMessage(body: unknown): unknown {
    if (!body || typeof body !== 'object' || Array.isArray(body)) {
      return body;
    }

    const result = body as Record<string, unknown>;
    if (typeof result['ErrorMessage'] !== 'string') {
      return body;
    }

    const translated = this.customerContext.displayText(result['ErrorMessage']);
    return translated === result['ErrorMessage']
      ? body
      : { ...result, ErrorMessage: translated };
  }
}

